import React from 'react';
import Navbar from './landing/Navbar';
import HeroSection from './landing/HeroSection';
import ProblemSection from './landing/ProblemSection';
import ExpertDiscovery from './landing/ExpertDiscovery';
import TribeDiscovery from './landing/TribeDiscovery';
import FeaturesSection from './landing/FeaturesSection';
import AppGallery from './landing/AppGallery';
import Footer from './landing/Footer';
import Seo from './seo/Seo';

const LandingPage = () => {
  return (
    <>
      <Seo
        title="WealthDost | Trust-First Finance Community"
        description="Join WealthDost for credible expert insights, real-time market discussions, and investor tribes built for serious wealth creation."
        path="/"
      />
      <main className="min-h-screen bg-[#0F172A] overflow-x-hidden" data-testid="landing-page">
        {/* Subtle noise overlay */}
        <div className="noise-overlay" />
        
        {/* Navigation */}
        <Navbar />
        
        {/* Hero Section */}
        <HeroSection />
        
        {/* Problem Section */}
        <ProblemSection />
        
        {/* Expert Discovery */}
        <ExpertDiscovery />
        
        {/* Tribe Discovery */}
        <TribeDiscovery />
        
        {/* Features Section */}
        <FeaturesSection />
        
        {/* App Gallery */}
        <AppGallery />
        
        {/* Footer */}
        <Footer />
      </main>
    </>
  );
};

export default LandingPage;
